<template>
    <div class="al-teaser news-item" :id="detail.Id">
        <p class="teaser-category category-search">
            {{detail.Tags}} | {{detail.CustomDate}}
        </p>
        <div class="control-wrapper ff-rte">
            <h3>{{detail.Titel}}</h3>
            <div>{{ detail.Vorschautext }}</div>
        </div>
        <p class="teaser-button">
            <a href="#" @click.prevent="openResultUrl()">{{read_more_text}}</a>
        </p>
    </div>
</template>

<script setup lang="ts">
import { emitterInstance } from '@/classes/emitter';
import type { NewsDetail } from './News';


const props = defineProps<{
  detail: NewsDetail;
  read_more_text: string;
  emitreadmore: string;
}>();

function openResultUrl(){
    const urlItem = {key:props.detail.Id, url: props.detail.Url};
    emitterInstance.emit(props.emitreadmore, urlItem);
}
</script>